import { createTheme, PaletteOptions, SimplePaletteColorOptions } from '@mui/material/styles';
import { WhiteLabelingColors } from '../../../state/ducks/company/types';
import { ThemeEnv } from './utils/types';

const defaultPalette: PaletteOptions = {
  primary: {
    main: '#0066FF',
    contrastText: '#fff',
    light: '#dbe9ff',
    dark: '#003dcb',
  } as SimplePaletteColorOptions,
  secondary: {
    light: '#B3F9F5',
    dark: '#29064C',
    main: '#6E09EA',
    contrastText: '#fff',
  } as SimplePaletteColorOptions,
  background: {
    default: '#5C9DFF',
    paper: '#fff',
  },
  text: {
    primary: '#4d4d4d',
    secondary: '#252525',
    disabled: '#797979',
  },
};

const devPalette: PaletteOptions = {
  ...defaultPalette,
  secondary: {
    dark: '#FFCA00',
    main: '#EBBA00',
    contrastText: '#29064C',
    light: '#0066FF',
  } as SimplePaletteColorOptions,
};

const demoPalette: PaletteOptions = {
  ...defaultPalette,
  secondary: {
    dark: '#C42260',
    main: '#D52568',
    contrastText: '#fff',
  } as SimplePaletteColorOptions,
};

const sandboxPalette: PaletteOptions = {
  ...defaultPalette,
  primary: {
    main: '#FF7600',
    contrastText: '#FFFFFF',
  } as SimplePaletteColorOptions,
  secondary: {
    main: '#FF7600',
    contrastText: '#FFFFFF',
  } as SimplePaletteColorOptions,
  background: {
    ...defaultPalette.background,
    default: '#5D666F',
  },
};

export const createAppPalette = (
  themeEnv: ThemeEnv,
  customColors: WhiteLabelingColors,
): PaletteOptions => {
  let palette: PaletteOptions;

  switch (themeEnv) {
    case ThemeEnv.DEMO_THEME:
      palette = demoPalette;
      break;
    case ThemeEnv.DEV_THEME:
      palette = devPalette;
      break;
    case ThemeEnv.SANDBOX_THEME:
      palette = sandboxPalette;
      break;
    default:
      palette = defaultPalette;
  }

  return {
    ...palette,
    primary: {
      ...palette.primary,
      main: customColors.primary || (palette.primary as SimplePaletteColorOptions)?.main || '#0066FF',
      contrastText: customColors.primaryContrastText || (palette.primary as SimplePaletteColorOptions)?.contrastText || '#fff',
    },
    secondary: {
      ...palette.secondary,
      main: customColors.secondary || (palette.secondary as SimplePaletteColorOptions)?.main || '#6E09EA',
      contrastText:
        customColors.secondaryContrastText || (palette.secondary as SimplePaletteColorOptions)?.contrastText || '#fff',
    },
    background: {
      ...palette.background,
      default: customColors.defaultBackground || palette.background?.default || '#5C9DFF',
    },
  };
};

export const muiTheme = createTheme();
